import type { ProposalListItem } from '../../types/agent';
import { Link } from 'react-router-dom';

// Coach-facing labels for backend trigger_type enum values. Falls back to
// snake_case → Title Case for any new trigger type not yet listed here so
// the UI never leaks a raw enum identifier.
const TRIGGER_TYPE_LABELS: Record<string, string> = {
  risk_tier_escalation: 'Risk escalation',
  scheduled_checkin: 'Scheduled check-in',
};

const formatTriggerType = (raw: string): string =>
  TRIGGER_TYPE_LABELS[raw] ??
  raw.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase());

export function ProposalCard({ p }: { p: ProposalListItem }) {
  return (
    <Link
      to={`/agent/${p.id}`}
      className="block border border-neutral-300 dark:border-neutral-700 p-4 hover:bg-neutral-50 dark:hover:bg-neutral-800/60"
    >
      <div className="flex justify-between">
        <div>
          <div className="font-semibold">{p.athlete_name}</div>
          <div className="text-sm text-neutral-500 dark:text-neutral-400">{p.team_name}</div>
        </div>
        <div className="text-right">
          <span className="inline-block px-2 py-0.5 bg-neutral-200 dark:bg-neutral-700 text-xs">
            {formatTriggerType(p.trigger_type)}
          </span>
          <div className="text-xs text-neutral-500 dark:text-neutral-400 mt-1">
            {p.action_count} actions
          </div>
        </div>
      </div>
      <p className="mt-2 text-sm">{p.summary}</p>
      <div className="text-xs text-neutral-500 dark:text-neutral-400 mt-2">
        {new Date(p.created_at).toLocaleString()}
      </div>
    </Link>
  );
}
